// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1374":"ef005932","4958":"e862c51a","9684":"911cb80b"}[chunkId] + ".chunk.css";
};